import React, { JSX } from "react";
import { IconSizes } from "../icons/constants/icon-sizes";
import { Icon } from "../icons/icon";
import { Icons } from "../icons/constants/icons";

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const Spinner: React.FC = (): JSX.Element => {
    return (
        <div className="h-full flex justify-center items-center">
            <Icon cssClassName={"text-center"} type={Icons.Spinner} size={IconSizes.Large} />
        </div>
    );
};

// #endregion Component

export { Spinner };
